module.exports = __webpack_public_path__ + "static/media/chaves.1ac337ac.png";